"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIfsAccessoryCodeFromVehicle = exports.IfsAvailabilityCode = exports.IfsAccessoryCode = void 0;
var IfsAccessoryCode;
(function (IfsAccessoryCode) {
    IfsAccessoryCode["PERSONAL"] = "TILB-${make}-PERS";
    IfsAccessoryCode["PERSONAL_ELECTRIC"] = "TILB-${make}-PERS-EL";
    IfsAccessoryCode["VAN"] = "TILB-${make}-VAR-EL";
    IfsAccessoryCode["VAN_ELECTRIC"] = "TILB-${make}-VAR-EL";
    IfsAccessoryCode["TRUCK"] = "TILB-${make}-LAST";
    IfsAccessoryCode["TRUCK_ELECTRIC"] = "TILB-${make}-LAST-EL";
    IfsAccessoryCode["BUS"] = "TILB-${make}-BUSS";
    IfsAccessoryCode["BUS_ELECTRIC"] = "TILB-${make}-BUSS-EL";
})(IfsAccessoryCode = exports.IfsAccessoryCode || (exports.IfsAccessoryCode = {}));
var IfsAvailabilityCode;
(function (IfsAvailabilityCode) {
    IfsAvailabilityCode["Sold"] = "KU_AL";
    IfsAvailabilityCode["Reserved"] = "KU_TR";
    IfsAvailabilityCode["Free"] = "LA_AL";
    IfsAvailabilityCode["Demo"] = "DE_AL";
    IfsAvailabilityCode["SoldTaxi"] = "TA_AL";
})(IfsAvailabilityCode = exports.IfsAvailabilityCode || (exports.IfsAvailabilityCode = {}));
const getIfsAccessoryCodeFromVehicle = (vehicle, accessory) => {
    var _a, _b, _c, _d, _e;
    const vehicleType = (_b = (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.config) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.vehicleType;
    const make = (_d = (_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.config) === null || _c === void 0 ? void 0 : _c.model) === null || _d === void 0 ? void 0 : _d.make;
    const isVatExempt = accessory.vat === 0;
    let enumValue;
    switch (vehicleType) {
        case 'PB':
            enumValue = IfsAccessoryCode.PERSONAL;
            break;
        case 'EL':
            enumValue = isVatExempt ? IfsAccessoryCode.PERSONAL_ELECTRIC : IfsAccessoryCode.PERSONAL;
            break;
        case 'V2':
            enumValue = IfsAccessoryCode.VAN;
            break;
        case 'ELV':
            enumValue = isVatExempt ? IfsAccessoryCode.VAN_ELECTRIC : IfsAccessoryCode.VAN;
            break;
        // TODO: What will these values be in PIM?
        case 'Lastebil':
        case 'Buss':
        default:
            return null;
    }
    return (_e = enumValue === null || enumValue === void 0 ? void 0 : enumValue.replace('${make}', make)) !== null && _e !== void 0 ? _e : null;
};
exports.getIfsAccessoryCodeFromVehicle = getIfsAccessoryCodeFromVehicle;
//# sourceMappingURL=ifs.js.map